<template>
  <b-container fluid>
    <h1 class="text-center">{{tituloPagina}}</h1>
    <hr>
    <button v-on:click="updateData">Actualizar</button>

    <highcharts :options="chartOptions"></highcharts>
  </b-container>
</template>

<script>
import Solicitudsvc from '@/services/solicitudes'
import { Chart } from "highcharts-vue";
export default {
  name: "SolicitudesByNivel",
  components: {
    highcharts: Chart
  },
  data() {
    return {
      tituloPagina: "Solicitudes por Nivel",
      arreglosolicitudes: [],
      chartOptions: {
        title: {
            text: 'Solicitudes por Nivel'
        },
        chart: {
          height: '100%',
          width: 1000,
          type: "bar",
          events: {
            redraw(event) {
              console.log("EVENT", event);
            }
          }
        },
        xAxis: {
            categories: [],
            crosshair: true
        },
        plotOptions: {
        column: {
            showInLegend: false,
            pointPadding: 0.2,
            borderWidth: 0,
            dataLabels: {
            allowOverlap: true,
            enabled: true
            },
        }
        },
        series: [
          {
            name: 'Cantidad de Solicitudes',
            data: [] // sample data
          }
        ]
      }
    };
  },
  methods: {
    updateData() {
      Solicitudsvc.getLista({ order: "desc", limit: 6000, destinosolicitud: 3, incluyecargopersonal: true })
        .then(response => {
          var articulosejex = [];
          var cantidadsolicitudesejey = [];

          response.data.rows.forEach(f => {
            this.arreglosolicitudes.push(f);
          });
          console.log(this.arreglosolicitudes);
          var counts = this.arreglosolicitudes.reduce((p, c) => {
            var name =
              c.ListaCargoPersonal.length > 0 ? (c.ListaCargoPersonal[0].CargoEstablecimiento != null ? c.ListaCargoPersonal[0].CargoEstablecimiento.UnidadEducativaNivelString : 'NULL') : 'NULL';
            if (!p.hasOwnProperty(name)) {
              p[name] = 0;
            }
            p[name]++;
            return p;
          }, {});
          console.log(counts);
          var cantidadsolicitudesejey = Object.keys(counts).map(function(key) {
            return counts[key];
          });

          var articulosejex = Object.keys(counts).map(function(key) {
            return key;
          });
          console.log(cantidadsolicitudesejey);
          console.log(articulosejex);
          this.chartOptions.series[0].data = cantidadsolicitudesejey;
          this.chartOptions.xAxis.categories = articulosejex;
        })
        .catch(error => {
          console.log("No se encontro el listado ", error);
        });
    }
  },
  watch: {
    title(newValue) {
      this.chartOptions.title.text = newValue;
    },
    points(newValue) {
      this.chartOptions.series[0].data = newValue;
    },
    chartType(newValue) {
      this.chartOptions.chart.type = newValue.toLowerCase();
    },
    seriesColor(newValue) {
      this.chartOptions.series[0].color = newValue.toLowerCase();
    },
    animationDuration(newValue) {
      this.updateArgs[2].duration = Number(newValue);
    }
  },
  created() {}
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/reportes/SolicitudesByNivel.vue